import { Link } from "react-router-dom";

const PageHero = ({ overline, title, italic, description, image, cta, overlayImage, overlayAlt }) => {
  return (
    <section className="relative overflow-hidden bg-sand" data-testid="page-hero">
      {/* Decorative blobs */}
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] bg-gold/25 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-[420px] h-[420px] bg-sage/20 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative container-tm pt-16 pb-16 lg:pt-20 lg:pb-24 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <span className="overline">{overline}</span>
          <h1 className="mt-5 font-serif font-light text-ink text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.025em]">
            {title}
            {italic && <span className="italic text-gold font-normal"> {italic}</span>}.
          </h1>
          {description && (
            <p className="mt-6 font-sans text-ink/70 text-base md:text-lg max-w-2xl leading-relaxed">
              {description}
            </p>
          )}
          {cta && (
            <div className="mt-9">
              {cta.to && cta.to.startsWith("#") ? (
                <a
                  href={cta.to}
                  className="btn-accent"
                  data-testid="page-hero-cta"
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.getElementById(cta.to.slice(1));
                    if (el) {
                      const top = el.getBoundingClientRect().top + window.scrollY - 90;
                      window.scrollTo({ top, behavior: "smooth" });
                    }
                  }}
                >
                  {cta.label}
                </a>
              ) : (
                <Link to={cta.to} className="btn-accent" data-testid="page-hero-cta">
                  {cta.label}
                </Link>
              )}
            </div>
          )}
        </div>

        {image && (
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] lg:aspect-square rounded-3xl overflow-visible">
              <div className="absolute inset-0 rounded-3xl overflow-hidden shadow-lift">
                <img
                  src={image}
                  alt=""
                  className="w-full h-full object-cover animate-slow-zoom"
                />
              </div>
              {overlayImage && (
                <img
                  src={overlayImage}
                  alt={overlayAlt || ""}
                  className="absolute -bottom-6 -right-6 sm:bottom-6 sm:right-6 w-28 sm:w-36 lg:w-44 rounded-full shadow-lift z-10 ring-1 ring-white/40"
                  style={{ transform: "rotate(-8deg)" }}
                  loading="lazy"
                  data-testid="page-hero-overlay"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
